module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "modal fade in"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.problemDevices),
      expression: "problemDevices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "problemDevices"
    },
    domProps: {
      "checked": Array.isArray(_vm.problemDevices) ? _vm._i(_vm.problemDevices, null) > -1 : (_vm.problemDevices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.problemDevices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.problemDevices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.problemDevices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.problemDevices = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "problemDevices"
    }
  }, [_vm._v("Problem Devices")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateLogs),
      expression: "updateLogs"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "appsUpdateLogs"
    },
    domProps: {
      "checked": Array.isArray(_vm.updateLogs) ? _vm._i(_vm.updateLogs, null) > -1 : (_vm.updateLogs)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.updateLogs,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.updateLogs = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.updateLogs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.updateLogs = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "appsUpdateLogs"
    }
  }, [_vm._v("Update Logs")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Privileges")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-271b4582", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-271b4582"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/PrivilegeModal.vue
// module id = 461
// module chunks = 1